"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBreadcrumb = addBreadcrumb;

var _currentScopes = require("./currentScopes.js");

var _logger = require("./utils-hoist/logger.js");

var _time = require("./utils-hoist/time.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */

function addBreadcrumb(breadcrumb, hint) {
  const client = (0, _currentScopes.getClient)();
  const isolationScope = (0, _currentScopes.getIsolationScope)();
  if (!client) return;

  const _client$getOptions = client.getOptions(),
        _client$getOptions$be = _client$getOptions.beforeBreadcrumb,
        beforeBreadcrumb = _client$getOptions$be === void 0 ? null : _client$getOptions$be,
        _client$getOptions$ma = _client$getOptions.maxBreadcrumbs,
        maxBreadcrumbs = _client$getOptions$ma === void 0 ? DEFAULT_BREADCRUMBS : _client$getOptions$ma;

  if (maxBreadcrumbs <= 0) return;
  const timestamp = (0, _time.dateTimestampInSeconds)();

  const mergedBreadcrumb = _objectSpread({
    timestamp
  }, breadcrumb);

  const finalBreadcrumb = beforeBreadcrumb ? (0, _logger.consoleSandbox)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
  if (finalBreadcrumb === null) return;

  if (client.emit) {
    client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
  }

  isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}